module.exports = __webpack_public_path__ + "themes/non-default/triangles.d069cdfa41ac01e39b99e824cd8592fd.png";